import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { Popup } from 'semantic-ui-react';
import {
  Header,
} from './styles';

const TableHeader = (props) => {
  const {
    name,
    isMerged,
    isDefault,
  } = props;

  const [showPopup, setShowPopup] = useState(false);

  const handleHover = ({ currentTarget }) => {
    const {
      offsetWidth,
      scrollWidth,
    } = currentTarget;

    if (offsetWidth <= scrollWidth) {
      setShowPopup(true);
    }
  };

  return (
    <Popup
      content={name}
      open={showPopup && !isDefault}
      position="top center"
      trigger={(
        <Header
          isMerged={isMerged}
          onMouseEnter={handleHover}
          onMouseLeave={() => setShowPopup(false)}
        >
          {name}
        </Header>
      )}

    />
  );
};

TableHeader.propTypes = {
  name: PropTypes.string.isRequired,
  isMerged: PropTypes.bool.isRequired,
  isDefault: PropTypes.bool,
};

TableHeader.defaultProps = {
  isDefault: false,
};

export default TableHeader;
